"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVerifiedOrganizationsForCurrentUser = exports.useVerifiedOrganizationalMembershipsForCurrentUser = exports.useVerifiedOrganizationIdsForCurrentUser = exports.useUnverifiedOrganizationsForCurrentUser = exports.useUnverifiedOrganizationalMembershipsForCurrentUser = exports.useUnverifiedOrganizationIdsForCurrentUser = exports.useStaffMembershipsForCurrentUser = exports.useAllOrganizationIdsForCurrentUser = void 0;
var _reactRedux = require("react-redux");
var _immutable = require("immutable");
var useVerifiedOrganizationalMembershipsForCurrentUser = function useVerifiedOrganizationalMembershipsForCurrentUser() {
  var session = (0, _reactRedux.useSelector)(function (state) {
    return state.session;
  });
  var organizationalMemberships = (0, _reactRedux.useSelector)(function (state) {
    return state.organizationalMemberships;
  });
  if (!session.get('is_logged_in')) return new _immutable.Map();
  var userId = session.get('current_user_id');
  if (!userId) return new _immutable.Map();

  // Get filtered Organizational Subscriptions
  return organizationalMemberships.filter(function (membership) {
    return membership.get('user_id') === userId && !membership.get('deactivated') && membership.get('verified');
  });
};
exports.useVerifiedOrganizationalMembershipsForCurrentUser = useVerifiedOrganizationalMembershipsForCurrentUser;
var useStaffMembershipsForCurrentUser = function useStaffMembershipsForCurrentUser() {
  return useVerifiedOrganizationalMembershipsForCurrentUser().filter(function (membership) {
    return ['admin', 'instructor', 'super admin'].includes(membership.get('role'));
  });
};
exports.useStaffMembershipsForCurrentUser = useStaffMembershipsForCurrentUser;
var useUnverifiedOrganizationalMembershipsForCurrentUser = function useUnverifiedOrganizationalMembershipsForCurrentUser() {
  var session = (0, _reactRedux.useSelector)(function (state) {
    return state.session;
  });
  var organizationalMemberships = (0, _reactRedux.useSelector)(function (state) {
    return state.organizationalMemberships;
  });
  if (!session.get('is_logged_in')) return new _immutable.Map();
  var userId = session.get('current_user_id');
  if (!userId) return new _immutable.Map();

  // Get filtered Organizational Subscriptions
  return organizationalMemberships.filter(function (membership) {
    return membership.get('user_id') === userId && !membership.get('deactivated') && !membership.get('verified');
  });
};

/* useAllOrganizationIdsForCurrentUser()
 *
 * Returns an unfiltered List of all of the current User's Organization IDs.
 */
exports.useUnverifiedOrganizationalMembershipsForCurrentUser = useUnverifiedOrganizationalMembershipsForCurrentUser;
var useAllOrganizationIdsForCurrentUser = function useAllOrganizationIdsForCurrentUser() {
  var session = (0, _reactRedux.useSelector)(function (state) {
    return state.session;
  });
  var organizationalMemberships = (0, _reactRedux.useSelector)(function (state) {
    return state.organizationalMemberships;
  });
  if (!session.get('is_logged_in')) return new _immutable.List();
  var userId = session.get('current_user_id');
  if (!userId) return new _immutable.List();

  // Get filtered Organizational Subscriptions
  return organizationalMemberships.toList().filter(function (membership) {
    return membership.get('user_id') === userId;
  }).map(function (membership) {
    return membership.get('organization_id');
  });
};

/* useVerifiedOrganizationIdsForCurrentUser()
 *
 * Returns a List of the current User's active/verified Organization IDs.
 */
exports.useAllOrganizationIdsForCurrentUser = useAllOrganizationIdsForCurrentUser;
var useVerifiedOrganizationIdsForCurrentUser = function useVerifiedOrganizationIdsForCurrentUser() {
  return useVerifiedOrganizationalMembershipsForCurrentUser().toList().map(function (membership) {
    return membership.get('organization_id');
  });
};

/* useUnverifiedOrganizationIdsForCurrentUser()
 *
 * Returns a List of the current User's active/unverified Organization IDs.
 */
exports.useVerifiedOrganizationIdsForCurrentUser = useVerifiedOrganizationIdsForCurrentUser;
var useUnverifiedOrganizationIdsForCurrentUser = function useUnverifiedOrganizationIdsForCurrentUser() {
  return useUnverifiedOrganizationalMembershipsForCurrentUser().toList().map(function (membership) {
    return membership.get('organization_id');
  });
};

/* useVerifiedOrganizationsForCurrentUser()
 *
 * Returns a List of the current User's active/verified Organizations.
 */
exports.useUnverifiedOrganizationIdsForCurrentUser = useUnverifiedOrganizationIdsForCurrentUser;
var useVerifiedOrganizationsForCurrentUser = function useVerifiedOrganizationsForCurrentUser() {
  var organizations = (0, _reactRedux.useSelector)(function (state) {
    return state.organizations;
  });
  var filteredOrganizationIds = useVerifiedOrganizationIdsForCurrentUser();
  return organizations.toList().filter(function (organization) {
    return filteredOrganizationIds.includes(organization.get('id'));
  });
};

/* useUnverifiedOrganizationsForCurrentUser()
 *
 * Returns a List of the current User's unverified Organizations.
 */
exports.useVerifiedOrganizationsForCurrentUser = useVerifiedOrganizationsForCurrentUser;
var useUnverifiedOrganizationsForCurrentUser = function useUnverifiedOrganizationsForCurrentUser() {
  var organizations = (0, _reactRedux.useSelector)(function (state) {
    return state.organizations;
  });
  var filteredOrganizationIds = useUnverifiedOrganizationIdsForCurrentUser();
  return organizations.toList().filter(function (organization) {
    return filteredOrganizationIds.includes(organization.get('id'));
  });
};
exports.useUnverifiedOrganizationsForCurrentUser = useUnverifiedOrganizationsForCurrentUser;